module.exports = __webpack_public_path__ + "src/assets/img/NDD1.d9e1f947.jpg";